import { useState } from 'react'
import CampaignApprovedTable from './campaignApprovedTable'
import CampaignRequestTable from './campaignRequestTable'
import CampaignLiveTable from './campaignLiveTable'

const Campaigns = () => {

    const [display, setDisplay] = useState(1)

    return (
        <div className='container-fluid'>
            <div className="header ">
                <div className="header-body">
                    <div className="row align-items-center">
                        <div className="col">
                            <h2 className="header-title">
                                Campaigns
                            </h2>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col">
                            <ul className="nav nav-tabs nav-overflow header-tabs">
                                <li className="nav-item">
                                    <div className={`nav-link ${(display === 1) ? 'active' : ''}`} onClick={() => { setDisplay(1) }}>
                                        New
                                        {/* <span className="badge rounded-pill bg-secondary-soft">10</span> */}
                                    </div>
                                </li>
                                <li className="nav-item ">
                                    <div className={`nav-link ${(display === 2) ? 'active' : ''}`} onClick={() => { setDisplay(2) }}>
                                        Approved
                                    </div>
                                </li>
                                <li className="nav-item ">
                                    <div className={`nav-link ${(display === 3) ? 'active' : ''}`} onClick={() => { setDisplay(3) }}>
                                        Live
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {(display === 1) ? <CampaignRequestTable /> : (display === 2) ? <CampaignApprovedTable /> : <CampaignLiveTable />}
            </div>
        </div>
    )

}

export default Campaigns
